/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Must_Confirm_Recovery_Code_SavedInputs */



/**
* | output |
* | --- |
* | "Please confirm that you have safely stored your recovery code." |
*
* @param {Auth_Must_Confirm_Recovery_Code_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_must_confirm_recovery_code_saved = /** @type {((inputs?: Auth_Must_Confirm_Recovery_Code_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Must_Confirm_Recovery_Code_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte bestätige, dass du deinen Wiederherstellungscode sicher gespeichert hast.")
	return /** @type {LocalizedString} */ ("Please confirm that you have safely stored your recovery code.")
});